import { Box, Card, Container, Grid, Modal } from "@mui/material";
import FormBox from "@mui/material/Box";
import { useEffect } from "react";
import React from "react";
import { UserProfile } from "../../data/userProfile";
import HTMLReactParser from "html-react-parser";

export default function SpeakerInfoModal(props: {show: any, onClose: ()=> void, speaker:UserProfile}){
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
        props.onClose();
    };
    useEffect(() => {
        setOpen(props.show);
    }, [props.show]);

    if (!open) return null;
    return (
        <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="speakerModal">
                <div className='speakerInfoForm'>
                    <img className="closeModal" src="https://cdn-icons-png.flaticon.com/128/399/399274.png" onClick={handleClose} alt=""/>
                    <Container>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} lg={3}>
                                    <center>
                                        <img className='KeynoteSpeakerImage' src={props.speaker.PictureLink} alt='KeyNoteSpeaker'/>
                                    </center>
                                </Grid>
                                <Grid item xs={12} lg={9} container justifyContent='flex-end' >
                                    <div className="SpeakerName"><h1 className='uppercase'><span className="textAccentColor5">{props.speaker.FirstName}</span> <span className="textAccentColor4">{props.speaker.LastName}</span></h1></div> 
                                    <br/>
                                    <div className="textAccentColor4">
                                        {HTMLReactParser(props.speaker.Biography)}
                                    </div>
                                    
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </div>
        </Modal>
    );
}
